/* Small native enhancements. Shopping and image links also work without this file. */
(() => {
  const galleries = new Map();
  const revealed = new WeakSet();
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = window.matchMedia('(max-width: 800px)');
  const key = value => String(value || '').split('?')[0];
  const matches = (root, selector) => [...(root.matches?.(selector) ? [root] : []), ...root.querySelectorAll(selector)];
  const revealObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); revealObserver.unobserve(entry.target); } });
  }, {threshold: .04, rootMargin: '0px 0px 10px 0px'}) : null;

  function init(root = document) {
    galleries.forEach((dispose, section) => { if (!document.contains(section)) { dispose(); galleries.delete(section); } });
    matches(root, '[data-catalog]').forEach(catalog => {
      const controls = catalog.querySelector('[data-catalog-view]');
      const grid = catalog.querySelector('.product-grid');
      if (!controls || !grid || controls.dataset.ready) return;
      controls.dataset.ready = 'true'; controls.hidden = false;
      controls.querySelectorAll('[data-view]').forEach(button => button.addEventListener('click', () => {
        grid.dataset.mobileView = button.dataset.view;
        controls.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      }));
    });
    matches(root, '[data-reveal], .section-heading, .trust-heading').forEach(item => {
      if (revealed.has(item) || !revealObserver || reduceMotion.matches) return;
      revealed.add(item);
      if (item.getBoundingClientRect().top < innerHeight) return;
      item.classList.add('motion-pending'); revealObserver.observe(item);
    });
    matches(root, '[data-product-section]').forEach(section => {
      if (galleries.has(section)) return;
      const link = section.querySelector('[data-main-image-link]');
      const image = section.querySelector('[data-main-image]');
      const dialog = section.querySelector('[data-lightbox]');
      const form = section.querySelector('[data-product-form]');
      const add = section.querySelector('[data-add-button]');
      const thumbnails = [...section.querySelectorAll('[data-thumbnail]')];
      const pictures = thumbnails.length ? thumbnails.map(thumb => ({src: thumb.dataset.full, large: thumb.dataset.large || thumb.href, alt: thumb.dataset.alt || image?.alt || '', thumb})) : image ? [{src: image.src, large: link?.href || image.src, alt: image.alt || ''}] : [];
      let index = Math.max(0, pictures.findIndex(picture => key(picture.src) === key(image?.src)));
      let returnFocus;
      const counter = section.querySelector('[data-gallery-counter]');
      const nav = section.querySelector('[data-gallery-nav]');
      const zoom = dialog?.querySelector('[data-lightbox-zoom]');
      const stage = dialog?.querySelector('[data-lightbox-stage]');
      const enlarged = dialog?.querySelector('[data-lightbox-image]');
      const caption = dialog?.querySelector('[data-lightbox-caption]');
      const purchase = section.querySelector('[data-mobile-purchase]');
      const mobileAdd = section.querySelector('[data-mobile-add]');
      const price = section.querySelector('[data-product-price]');
      const message = section.querySelector('[data-product-message]');
      const footer = document.querySelector('.site-footer');
      let footerVisible = false;
      if (nav && pictures.length > 1) nav.hidden = false;

      const syncCounter = () => { if (counter) counter.textContent = `${index + 1} / ${pictures.length}`; };
      const setZoom = value => {
        if (!stage || !zoom) return;
        stage.classList.toggle('is-zoomed', value);
        zoom.setAttribute('aria-pressed', String(value));
        zoom.setAttribute('aria-label', value ? 'Réduire la photo' : 'Agrandir la photo');
        stage.scrollTop = 0; stage.scrollLeft = 0;
      };
      const paintDialog = () => {
        if (!enlarged || !pictures[index]) return;
        enlarged.src = pictures[index].large;
        enlarged.alt = pictures[index].alt;
        caption.textContent = `${index + 1} / ${pictures.length}`;
        dialog.querySelector('[data-lightbox-prev]').disabled = pictures.length < 2;
        dialog.querySelector('[data-lightbox-next]').disabled = pictures.length < 2;
        setZoom(false);
      };
      const show = target => {
        if (!pictures.length) return;
        index = (target + pictures.length) % pictures.length;
        if (pictures[index].thumb) pictures[index].thumb.click();
        else if (image) { image.src = pictures[index].src; image.alt = pictures[index].alt; }
        syncCounter();
        if (dialog?.open) paintDialog();
      };
      section.addEventListener('beldi:image-change', event => {
        const target = pictures.findIndex(picture => key(picture.src) === key(event.detail.src));
        if (target >= 0) index = target;
        syncCounter();
      });
      section.querySelector('[data-gallery-prev]')?.addEventListener('click', () => show(index - 1));
      section.querySelector('[data-gallery-next]')?.addEventListener('click', () => show(index + 1));
      syncCounter();

      const syncPurchase = () => {
        if (!purchase || !add || !mobileAdd) return;
        if (price) section.querySelector('[data-mobile-price]').textContent = price.textContent;
        const busy = add.getAttribute('aria-busy') === 'true';
        mobileAdd.disabled = add.disabled;
        mobileAdd.setAttribute('aria-busy', String(busy));
        mobileAdd.firstChild.textContent = busy ? 'Ajout en cours… ' : add.disabled ? 'Produit épuisé ' : 'Ajouter au panier ';
        const pastButton = add.getBoundingClientRect().bottom < 0;
        purchase.hidden = !mobile.matches || !pastButton || footerVisible || Boolean(dialog?.open);
        document.body.classList.toggle('has-purchase-bar', !purchase.hidden);
        if (message) section.querySelector('[data-mobile-status]').textContent = message.textContent;
      };
      if (link && dialog && typeof dialog.showModal === 'function' && pictures.length) {
        link.addEventListener('click', event => {
          event.preventDefault(); returnFocus = document.activeElement;
          paintDialog(); dialog.showModal(); document.body.classList.add('lightbox-open');
          syncPurchase(); dialog.querySelector('[data-lightbox-close]').focus();
        });
        dialog.querySelector('[data-lightbox-close]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('close', () => { document.body.classList.remove('lightbox-open'); setZoom(false); syncPurchase(); returnFocus?.focus(); });
        dialog.querySelector('[data-lightbox-prev]').addEventListener('click', () => show(index - 1));
        dialog.querySelector('[data-lightbox-next]').addEventListener('click', () => show(index + 1));
        zoom.addEventListener('click', () => setZoom(!stage.classList.contains('is-zoomed')));
        dialog.addEventListener('keydown', event => {
          if (event.key === 'ArrowLeft') { event.preventDefault(); show(index - 1); }
          if (event.key === 'ArrowRight') { event.preventDefault(); show(index + 1); }
          if (['+', '='].includes(event.key)) { event.preventDefault(); setZoom(true); }
          if (event.key === '-') { event.preventDefault(); setZoom(false); }
        });
        let start;
        stage.addEventListener('touchstart', event => { start = event.touches.length === 1 ? {x:event.touches[0].clientX,y:event.touches[0].clientY} : null; }, {passive:true});
        stage.addEventListener('touchend', event => {
          if (!start || stage.classList.contains('is-zoomed') || !event.changedTouches.length) return;
          const dx = event.changedTouches[0].clientX - start.x, dy = event.changedTouches[0].clientY - start.y;
          if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) && pictures.length > 1) show(index + (dx < 0 ? 1 : -1));
          start = null;
        }, {passive:true});
      }
      mobileAdd?.addEventListener('click', () => { if (add && !add.disabled) form?.requestSubmit(add); });
      const purchaseObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
        entries.forEach(entry => { if (entry.target === footer) footerVisible = entry.isIntersecting; }); syncPurchase();
      }, {threshold:0}) : null;
      if (add) purchaseObserver?.observe(add);
      if (footer) purchaseObserver?.observe(footer);
      const purchaseMutation = new MutationObserver(syncPurchase);
      if (add) purchaseMutation.observe(add, {attributes:true, childList:true, subtree:true});
      if (price) purchaseMutation.observe(price, {childList:true,subtree:true});
      if (message) purchaseMutation.observe(message, {childList:true,subtree:true});
      mobile.addEventListener('change', syncPurchase);
      syncPurchase();
      galleries.set(section, () => { purchaseObserver?.disconnect(); purchaseMutation.disconnect(); mobile.removeEventListener('change',syncPurchase); if (dialog?.open) dialog.close(); document.body.classList.remove('has-purchase-bar','lightbox-open'); });
    });
  }
  const header = document.querySelector('.shopify-section-group-header-group');
  const headerSize = () => { if (header) document.documentElement.style.setProperty('--header-height', `${Math.round(header.getBoundingClientRect().height)}px`); };
  if (header && 'ResizeObserver' in window) new ResizeObserver(headerSize).observe(header);
  headerSize(); init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', () => { galleries.forEach((dispose, section) => { if (!document.contains(section)) { dispose(); galleries.delete(section); } }); });
})();
